<template>
  <component
    :is="group ? TransitionGroup : Transition"
    enter-active-class="transition duration-200 ease-out"
    leave-active-class="transition duration-200 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { Transition, TransitionGroup } from 'vue';

import type { TransitionProps } from '~/components/transitions/types';

withDefaults(defineProps<TransitionProps>(), { group: false });
</script>
